import actions from './actions';
import getters from './getters';
import mutations from './mutations';

function state() {
  return {
    syndicates: [],
    syndicate: false,
    loading: false,
    formLoading: false,
    error: false,
    success: false,
    syndicateLink: [],
  };
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/index.js